import { FC } from 'react';
import { COLORS } from '~/data/ui/colors';
import {
  Box,
  Button,
  Snackbar,
  SnackbarContent,
  Typography,
} from '@mui/material';
import { ToastStyle, useStyles } from './useStyles';

interface IToastProps {
  title: string;
  icon?: JSX.Element;
  open: boolean;
  handleClose: () => void;
}

export const Toast: FC<IToastProps> = ({ title, icon, open, handleClose }) => {
  const classes = useStyles();

  const action = (
    <Button size="small" onClick={handleClose} sx={ToastStyle}>
      <Box sx={classes.ToastDivStyle}>
        {icon}
        <Typography variant="h4">{title}</Typography>
      </Box>
    </Button>
  );

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <SnackbarContent
        sx={ToastStyle}
        action={action}
        color={COLORS.primary.light}
      />
    </Snackbar>
  );
};
